import React from "react";
import styled, { keyframes } from "styled-components";
import { MdClose } from "react-icons/md";

const grow = keyframes`
    from {
        height: 0;
        padding: 0 0;
    }
    to {
        padding: 16px 0;
    }
`;

const text = keyframes`
    from {
        opacity: 0;
    }
    to {
        opacity: 1;
    }
`;

const close = keyframes`
    from {
        opacity: 0;
    }
    to {
        opacity: 0.4;
    }
`;

const fold = keyframes`
    50% {
        opacity: 1;
        height: 50%;
    }
    100% {
        opacity: 0;
        height: 50%;
    }
`;

const side_triangle_fold__left = keyframes`
    0% {
        border-width: 26px 0 26px 14px;
    }
    100% {
        border-width: 26px 0 26px 0;
    }
`;

const side_triangle_fold__right = keyframes`
    0% {
        border-width: 26px 14px 26px 0;
    }
    100% {
        border-width: 26px 0 26px 0;
    }
`;

const Container = styled.div`
  animation: ${grow} 0.8s both;
  background-color: #f46d42;
  background-image: linear-gradient(90deg, #ff6e3a, #fc9548);
  color: #fff;
  text-align: center;
  height: 52px;
  font-size: 14px;
  font-weight: 700;
  position: relative;
  overflow: hidden;
  .fold_effect {
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    .fold_left {
      animation: ${side_triangle_fold__left} 0.8s;
      width: 0;
      position: absolute;
      left: 0;
      top: 0;
      bottom: 0;
      border-style: solid;
      border-color: transparent transparent transparent #ffffff;
    }
    .fold_right {
      animation: ${side_triangle_fold__right} 0.8s;
      width: 0;
      position: absolute;
      right: 0;
      top: 0;
      bottom: 0;
      border-style: solid;
      border-color: transparent #ffffff transparent transparent;
    }
    .top {
      animation: ${fold} 0.6s both;
      background-color: rgba(0, 0, 0, 0.1);
      position: absolute;
      left: 0;
      top: 0;
      right: 0;
    }
    .bottom {
      animation: ${fold} 0.6s both;
      background-color: rgba(255, 255, 255, 0.4);
      position: absolute;
      left: 0;
      bottom: 0;
      right: 0;
    }
  }
  p {
    opacity: 0;
    animation: ${text} 0.5s 0.8s both;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 0 42px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .close {
    animation: ${close} 0.5s 0.5s both;
    cursor: pointer;
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    width: 42px;
    display: flex;
    align-items: center;
    justify-content: center;
    opacity: 0.4;
    &:hover {
      svg {
        opacity: 0.9;
      }
    }
    svg {
      opacity: 0.55;
      width: 24px;
      height: 24px;
      fill: #000;
    }
  }
`;

interface ErrorDialogProps {
  error_message: string;
  onClose: () => void;
}

export default ({ error_message, onClose }: ErrorDialogProps) => (
  <Container>
    <div className="fold_effect">
      <div className="fold_left" />
      <div className="top" />
      <div className="bottom" />
      <div className="fold_right" />
    </div>
    <p>{error_message}</p>
    <div className="close" onClick={onClose}>
      <MdClose />
    </div>
  </Container>
);



// WEBPACK FOOTER //
// ./src/components/ErrorDialog.tsx